import MyContextProvider from "./AuthContext"
import MyExternalContextProvider from "./ExtContext"


// Instaed of directly nesting multiple MyContextProviders in App.js, MyCombineContextProvider is going to do that

function MyCombineContextProvider({children}){
    return(
        <div>
            <MyExternalContextProvider>
            <MyContextProvider>
            {children}
            </MyContextProvider>
            </MyExternalContextProvider>
        </div>
    )
}



export default MyCombineContextProvider